export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";